import { render } from "./RoleNameAndNalbs.vue?vue&type=template&id=2f8eda4e"
import script from "./RoleNameAndNalbs.vue?vue&type=script&lang=js"
export * from "./RoleNameAndNalbs.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "../i18n/RoleNameAndNalbs.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fpeeristics%2Frails-frontend%2Fapp%2Fassets%2Fvue%2Fnetworks%2Fadmin%2Fcontainer_types%2Fcomponents%2FRoleNameAndNalbs.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__